import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const RadioGroupWrapper = styled.div`
  /* border: 1px solid red; */
  margin-bottom: 7.5px;
  font-family: ${props => props.theme.fonts.fontfaceBeta};
  text-transform: capitalize;

  label {
    margin-left: 7.5px;
    vertical-align: middle;
    /* border: 1px solid red; */
  }
`;

function RadioGroup({ name, items, active, onChange, tabindex = -1 }) {
  return (
    <>
      {items.map(item => {
        const value = item.value;
        const checked = value === active;

        return (
          <RadioGroupWrapper key={value}>
            <input
              tabIndex={tabindex}
              className="inline"
              type="radio"
              value={value}
              name={name}
              id={value}
              checked={checked}
              onChange={e => onChange && onChange(e.target.value)}
            />
            <label className="inline" htmlFor={value}>
              {item.label}
            </label>
          </RadioGroupWrapper>
        );
      })}
    </>
  );
}

RadioGroup.propTypes = {
  onChange: PropTypes.func,
  active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  tabindex: PropTypes.number
};

export default RadioGroup;
